module.exports = __webpack_public_path__ + "media/images/img_thank_you-86d8e7f489013dc67ccb6e7f7e1314e8.png";